export const layerZIndexMap = {
  map: 1,
  compass: 2,
  situationDisplay: 0,
  tracks: 100,
  dcb: 90,
};
